// signupService.js
import { auth } from './firebase';
import { signInWithEmailAndPassword, sendEmailVerification } from 'firebase/auth';
import { fnUrl } from './functionsBase';

const FN_SIGNUP_COMPANY = fnUrl('signupCompany');
const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export const validateEmail = (email) => EMAIL_RE.test((email || '').trim());

// Creates the Auth user + companies doc + appUsers doc (role: admin) all at once via the Cloud
// Function (see functions/companySignup.js for why this needs its own unauthenticated entry
// point rather than reusing createUser), then signs the browser in and kicks off Firebase's own
// built-in verification email — no custom email-sending infrastructure exists in this app yet,
// so this is the simplest real option rather than a custom code, and requires nothing at
// Settings > Integration Settings to already be configured (which a brand-new company won't
// have yet). Firebase Auth's onAuthStateChanged listener in App.js picks up the sign-in
// automatically and hands off to the normal Dashboard the same way any other login does.
export const signupCompany = async (data) => {
  const response = await fetch(FN_SIGNUP_COMPANY, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(data)
  });
  const result = await response.json();
  if (!result.success) {
    throw new Error(result.error || 'Signup failed');
  }
  const credential = await signInWithEmailAndPassword(auth, data.email, data.password);
  await sendEmailVerification(credential.user).catch((error) => {
    // A failed verification email shouldn't block the person from reaching their new account —
    // they can resend it later from the welcome banner (see resendVerificationEmail below).
    console.error('Failed to send verification email:', error);
  });
  // App.js's handleLoginSuccess reads companyIds/userRole/technicianName straight from
  // localStorage rather than re-deriving them (that's RoleLogin.js's own async Firestore
  // lookup's job on a normal login) — set the same way RoleLogin.js's handleLogin does before
  // calling its own onLoginSuccess. Without this, handleLoginSuccess fell back to its own
  // ['cpp'] default for the instant before App.js's separate onAuthStateChanged listener
  // corrected it, meaning a freshly signed-up company briefly (and only ever
  // permission-denied, but still visibly in the console) tried to load the real cpp account's
  // data instead of its own brand-new, empty one.
  localStorage.setItem('userRoles', JSON.stringify(['admin']));
  localStorage.setItem('technicianName', data.name);
  localStorage.setItem('companyIds', JSON.stringify([result.companyId]));
  return { uid: result.uid, companyId: result.companyId, user: credential.user };
};

export const resendVerificationEmail = async () => {
  if (!auth.currentUser) return;
  await sendEmailVerification(auth.currentUser);
};
